<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="width: 800px;">
        <b-row style="margin: 0px; padding: 12px 22px 0px 2px;">
            <b-col style="padding-left: 0; padding-right: 0">
                <h5>Baumnummer: {{tableData[0].tree_number}}</h5>
                <b-table striped bordered responsive hover :items="tableData" :fields="fields" v-on:row-clicked="onClick" style="max-height: 400px; cursor: pointer">
                    <template v-slot:cell(priority)="row">
                        <b-row style="margin: 0" v-if="row.item.priority === 3">
                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: red"></div>
                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                Hoch</p>
                        </b-row>
                        <b-row style="margin: 0" v-if="row.item.priority === 1">
                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: green"></div>
                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                Niedrig</p>
                        </b-row>
                        <b-row style="margin: 0" v-if="row.item.priority === 2">
                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: yellow"></div>
                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                Mäßig</p>
                        </b-row>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "AllTasksPopup",
        props: {
            tableData: {
                type: Array,
                default: () => []
            },
        },
        computed: {
            items: function() {
                console.log(this.tableData);
                const items =  this.tableData;
                return Array.isArray(items) ? items : items()
            },
            rows() {
                return this.tableData.length
            }
        },
        data: () => {
            return {
                fields: [
                    {key: "priority", label: "Priorität"},
                    {key: "task", label: "Maßnahme"},
                    {key: "create_date", label: "Erstellt", formatter: 'dateFormater'},
                    {key: "due_date", label: "Datum", formatter: 'dateFormater'},
                    {key: "finished_at", label: "Erledigt", formatter: 'dateFormater'},
                    {key: "note", label: "Notiz"},
                ]
            }
        },
        methods: {
            onClick(item, index, target) {
                this.$emit("task-clicked", item)
            },
            dateFormater(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },
        }
    }
</script>

<style scoped>
    .no-over-flow {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow-x: hidden;
    }
</style>
